<template>
    <div>
        <div v-if="ishomepage">
            <div v-for="route in pdaroutes" :key="route.path">
                <div class="flex-container">
                    <div class="card" v-for="child in route.children" :key="child.path">
                        <router-link :key="child.path" :to="child" class="div" style="text-align: center;">
                            <span class="icon-container" :style="cardstyle(child)">
                                <i :class="child.meta.icon?child.meta.icon:'el-icon-document'" />
                            </span>
                            <h3 class="title">{{ child.meta.title }}</h3>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <router-view v-if="!ishomepage" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import linq from 'linq'
export default {
    computed: {
        ...mapGetters([
            'permission_routes',
        ]),
        pdaroutes() {
            return linq.from(this.permission_routes).where(p => {
                return p.name === 'hep2'
            }).toArray()
        },
        ishomepage() {
            for (let i = 0; i < this.pdaroutes.length; i++) {
                console.log('ishomepage',this.pdaroutes[i].children, this.$route.name)
                if (linq.from(this.pdaroutes[i].children).where(c => c.name === this.$route.name).toArray().length > 0) {
                    return false
                }
            }
            return true
        }
    },
    methods: {
        cardstyle(route) {
            let style = {}
            console.log('route', route)
            if (route.meta && route.meta.color) {
                style.backgroundColor = route.meta.color
            }
            return style
        },
    }
}
</script>

<style scoped lang="less">
    @primary-color: #4361ee;
    @secondary-color: #3f37c9;
    @text-color: #333;
    @light-gray: #f8f9fa;
    @card-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
    @hover-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
    @transition: all 0.3s ease;
    @border-radius: 12px;
    /* 响应式断点 */
    @tablet: 900px;
    @mobile: 480px;
    .card-hover-effect {
        transition: @transition;
        &:hover {
            transform: translateY(-5px);
            box-shadow: @hover-shadow;
        }
    }
    .flex-center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .title{
        font-size: 20px;
        font-weight: bold;
        margin-top: 10px;
        margin-bottom: 10px;
        color: #333;
    }
    .flex-container {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        padding: 20px;
        background: white;
        border-radius: @border-radius;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        .card {
            flex: 0 0 calc(50% - 20px);
            display: flex;
            flex-direction: column;
            align-items: center;
            background: white;
            border-radius: @border-radius;
            padding: 30px 20px;
            box-shadow: @card-shadow;
            .card-hover-effect;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            background: lighten(@primary-color, 45%);
            text-align: center;
            .icon-container {
                .flex-center;
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background: lighten(@primary-color, 40%);
                margin-bottom: 25px;
                transition: @transition;
                i {
                    font-size: 36px;
                    color: @primary-color;
                    transition: @transition;
                }
            }
            .icon-container {
                background: @primary-color;
                transform: scale(1.05);
                i {
                    color: white;
                }
            }
            .title {
                font-size: 18px;
                color: @text-color;
                font-weight: 500;
                text-align: center;
                margin-bottom: 10px;
            }
            .subtitle {
                font-size: 14px;
                color: #777;
                text-align: center;
                line-height: 1.5;
            }
        }
    }
</style>